import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import useUsers from "src/api/hooks/useUsers";
import { queryKeys } from "src/api/queryKeys";
import { lang } from "src/language/Strings";
import { routes } from "src/routes";
import { findColorForDeviationType } from "src/utils/findColors";
import { objectTypes } from "src/consts/objectTypes";
import { useFilesForCompanyId } from "src/api/hooks/useFiles";
import { useMemo } from "react";
import { InspectionStatus } from "src/types/InspectionStatus";

const getLocalizedDeviationType = (name: string) => {
  switch (name) {
    case "Urgent":
      return lang.urgent;
    case "Improvement":
      return lang.improvement;
    case "Vandalism":
      return lang.vandalism;
    case "Other":
      return lang.other;
    default:
      return lang.other;
  }
};

export const getImageFileFromItem = (item: any) => {
  const result = [item.files?.[0]?.url, item.files?.[0]?.files?.[0],
    item.files?.[0]?.imageResonse?.urlx32,
    item.files?.[0]?.imageResonse?.urlx240,
    item.files?.[0]?.imageResonse?.urlOriginal].find(result => !String(result).includes("/?"));
  return result ?? "";
}
export function InspectionDataCard({
  item,
  visibleComponents,
  objectType,
}: {
  item: any;
  visibleComponents: number[];
  objectType: string;
}) {
  const { companyId, variationId, inspectionId, deviationId } = useParams();
  const nav = useNavigate();
  const queryClient = useQueryClient();
  // const { data: users } = useUsers();
  const { data: companyFiles } = useFilesForCompanyId();
  const idFiles = useMemo(
    () => companyFiles?.filter((f) => f.deviationId === Number(item.id)),
    [companyFiles, item.id]
  );

  return (
    <div
      className={`border-2 relative border-solid border-Grey4 border-l-4 border-b-2 grid grid-cols-7 p-1 h-42 min-h-28 select-none overflow-hidden max-w-full ${
        Number(inspectionId ?? deviationId ?? variationId) ===
          Number(item.id) && "bg-Grey4"
      }`}
      onClick={() => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.thumbnail(item.id),
        });
        if (objectType === objectTypes.Deviation && inspectionId) {
          nav(
            routes.Egenkontroller.Pages.Deviations.ShowById.url(
              companyId,
              inspectionId,
              item.id
            )
          );
        } else if (objectType === objectTypes.Deviation) {
          nav(routes.Deviation.Pages.Show.url(companyId, item.id));
        } else {
          nav(routes.Egenkontroller.Pages.Show.url(companyId, item.id));
        }
      }}
      id={`projectvariationDatacard-${item.id}`}
      key={`projectvariationDatacard-${item.id}`}
    >
      <div className="h-36 items-center col-span-2 p-2 flex flex-col pb-2 min-w-0 overflow-hidden">
        {idFiles?.length && idFiles?.length > 0 ? (
          <img
            className="h-28 max-h-28 max-w-full w-auto object-contain rounded-lg"
            src={
              getImageFileFromItem(item)
            }
            title={`Thumbnail for id: ${item.id}`}
          />
        ) : null}
        
      </div>
      <div className="h-full col-span-4 pl-2 flex flex-col py-1 min-w-0 overflow-hidden">
        <div className="truncate text-sm min-w-0 leading-tight">
          {item.title}
        </div>
        {item.title && item.title.length > 15 && (
          <div className="truncate text-sm min-w-0 leading-tight">{item.title}</div>
        )}
        {objectType === objectTypes.Deviation && (
          <div
            className={`truncate text-sm min-w-0 leading-tight text-${findColorForDeviationType(
              item.deviationType || ""
            )}`}
          >
            {getLocalizedDeviationType(item.deviationType || "Other")}
          </div>
        )}
        {/* {objectType === objectTypes.Inspection && (
          <div className="text-[#1242BA] truncate text-sm min-w-0 leading-tight">
            {item.information?.includes("https://") ? (
              <a
                href={item.information}
                target="_blank"
                className="text-SkaneGreen truncate block"
                rel="noopener noreferrer"
              >
                {lang.link}
              </a>
            ) : (
              <span className="truncate block">{item.information}</span>
            )}
          </div>
        )} */}

        {/* <div className="text-sm truncate min-w-0 leading-tight">
          {(users &&
            `${
              item.user?.firstName ||
              users?.find((u) => u.id === item.userId)?.firstName ||
              ""
            } ${
              item.user?.surname ||
              users?.find((u) => u.id === item.userId)?.surname ||
              ""
            }`) ||
            ""}
        </div> */}
        {objectType === objectTypes.Inspection && (
          <div className="truncate text-sm min-w-0 leading-tight">
            <i className="fa-solid fa-calendar-days text-Grey7 text-sm mr-1" ></i>{new Date(item.createdAt).toLocaleDateString()}
          </div>
        )}
        {objectType === objectTypes.Inspection && (
          <div className="h-6 w-full object-contain rounded-lg overflow-hidden">
            <small
              className={`truncate block text-m ${
                item.status === InspectionStatus.Finished
                  ? "text-SkaneGreen"
                  : "text-PrimaryRed"
              }`}
            >
              {/* {item.status === InspectionStatus.Finished ? lang.checked : ""} */}
              {lang.checked}: {item.status === InspectionStatus.Finished ? <i className="fa-solid fa-check text-SkaneGreen text-sm mr-1" ></i>: <i className="fa-solid fa-xmark text-PrimaryRed text-sm mr-1" ></i>}
            </small>
          </div>
        )}
      </div>
      <div className="h-full col-span-1 items-center flex p-2 min-w-0 overflow-hidden">
        <i className="fa-solid fa-greater-than text-PrimaryGreen text-2xl"></i>
      </div>
    </div>
  );
}
